<template>
  <div id="housingLeftOne" class="echarts"></div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,

  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import * as echarts from "echarts";
import { carColor } from "@/api/dataAnalysis/carAnalysis.js";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      echartsNameList: [],
      echartsValueList: [],
    });
    const refData = toRefs(data);
    const numberall = async () => {
      const res = await carColor();
      if (res.code == 0) {
        res.data.forEach((element) => {
          data.echartsNameList.push(element.name);
          data.echartsValueList.push(element.value);
        });
      }
    };
    const colorList = [
      "#5B8FF9",
      "#5AD8A6",
      "#5D7092",
      "#F6BD16",
      "#E8684A",
      "#6DC8EC",
      "#9270CA",
      "#FF9D4D",
      "#269A99",
      "#FF99C3",
    ];
    onMounted(async () => {
      await numberall();
      // echarts项目初始化
      const myChart = echarts.init(document.getElementById("housingLeftOne"));
      myChart.setOption({
        grid: {
          top: 40,
          left: 50,
          right: 30,
          bottom: 50,
          // containLabel: true
        },
        color: colorList,
        title: {
          // text: "年龄结构",
        },
        textStyle: {
          // 图列内容样式
          color: "#fff", // 字体颜色
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          data: data.echartsNameList,
          axisLine: {
            lineStyle: {
              color: "#08598f", // 横坐标线条颜色
            },
          },
        },
        yAxis: {
          height: 50,
          splitLine: {
            // 网格线
            lineStyle: {
              color: "#08598f",
              type: "dashed", // 设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, // 隐藏或显示
          },
        },
        series: [
          {
            itemStyle: {
              // color: new echarts.graphic.LinearGradient(
              //   0,
              //   1,
              //   0,
              //   0,
              //   [
              //     {
              //       offset: 0,
              //       color: "#8741d8" // 0% 处的颜色
              //     },
              //     {
              //       offset: 1,
              //       color: "#741fd5" // 100% 处的颜色
              //     }
              //   ],
              //   false
              // )
              // borderColor: "#5ea9d0"
            },
            barWidth: "50%",
            name: "",
            type: "bar",
            // data: [200, 400, 600, 200, 400, 600, 200],
            data: data.echartsValueList,
          },
        ],
      });
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    });
  },
});
</script>
<style lang="scss" scoped>
#housingLeftOne {
  width: 100%;
  height: 90%;
}
</style>
